import { Component } from '@angular/core';

@Component({
  selector: 'app-route-status',
  templateUrl: './route-status.component.html',
  styleUrls: ['./route-status.component.scss'],
  standalone: false,
})
export class RouteStatusComponent {
  statuses = [
    {
      label: $localize`Assigned`,
      value: $localize`Assigned`,
    },
    {
      label: $localize`Unassigned`,
      value: $localize`Unassigned`,
    },
  ];
}
